
import React from 'react';

class Header extends React.Component {
    render() {
        return (
            <header id="header-wrap">
                <nav className="navbar navbar-expand-md bg-inverse fixed-top scrolling-navbar">
                    <div className="container">
                        <a href="/" className="navbar-brand"><img src="assets/img/appx-logo.svg" alt="" /></a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="lni-menu"></i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            <ul className="navbar-nav mr-auto w-100 justify-content-end clearfix">
                                <li className="nav-item active">
                                    <a className="nav-link" href="#hero-area">
                                        Home
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#feature">
                                        Features
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#services">
                                        Services
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="#whyus">
                                        Why Us
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#products">
                                        Our Products
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" href="#contact">
                                        Contact Us
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/layouts/Header.js